import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

const MediaCard = ({ media, onDelete }) => {
  const [open, setOpen] = useState(false); // to control the modal for displaying the media
  const [confirmDelete, setConfirmDelete] = useState(false); // to control the delete confirmation
  const [showDeleteOptions, setShowDeleteOptions] = useState(false); // to control the delete options

  //oprning the modal
  const handleOpen = () => {
    setOpen(true); 
  };

  //closing the modal
  const handleClose = () => {
    setOpen(false); 
  };

  //show the delete options
  const handleDelete = () => {
    setShowDeleteOptions(true); 
  };

  //confirming the delete
  const confirmDeleteYes = () => {
    onDelete(media._id);
    // setShowDeleteOptions(false); 
  };

  //cancel the delete
  const confirmDeleteNo = () => {
    setShowDeleteOptions(false); // ביטול המחיקה
  };

  return (
    <>
      <Card className="media-card">
        {media.mediaType === 'image' ? (
          <CardMedia
            component="img"
            className="media-image"
            src={media.url}
            title={media.title || 'Media Item'}
          />
        ) : (
          <CardMedia
            component="video"
            className="media-image"
            src={media.url}
            title={media.title || 'Media Item'}
            controls
          />
        )}

        {!showDeleteOptions && (
          <CardActions>
            <Button size="medium" onClick={handleOpen}>הצג בגדול</Button>
            <Button size="medium" style={{ color: 'red' }} onClick={handleDelete}>מחיקה</Button>
          </CardActions>
        )}

        {showDeleteOptions && (
          <div>
            <Typography variant="body2" color="error">
              האם אתה בטוח שברצונך למחוק?
            </Typography>
            <Button size="small" onClick={confirmDeleteYes} style={{ color: 'red' }}>
              כן
            </Button>
            <Button size="small" onClick={confirmDeleteNo}>
              לא
            </Button>
          </div>
        )}
      </Card>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth 
        maxWidth="lg" 
      >
        <DialogTitle>{media.title || 'תצוגה מוגדלת'}</DialogTitle>
        <DialogContent>
          {media.mediaType === 'image' ? (
            <img src={media.url} alt={media.title} style={{ width: '100%', height: 'auto', maxHeight: '80vh' }} />
          ) : (
            <video src={media.url} controls style={{ width: '100%', height: 'auto', maxHeight: '80vh' }} />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            סגור
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MediaCard;
